<template>
  <div>
    <base-header v-if="!searchUserid" pageName="고객 검색" :popup="true"></base-header>
    <base-header v-else :prevBtnShow="true" pageName="고객 검색" :popup="true" ></base-header>

    <section id="wrap">
        <div class="search-input">
            <input type="search" v-model="searchCustNm" @keyup.enter="custSearch" placeholder="고객명을 입력해주세요.">
            <button type="button" class="search" title="검색" @click="custSearch"></button>
        </div>
        <ul class="search-result-cus">
            <li v-for="(cust, index) in custList" v-bind:key="index">
                <em :class="{ contract: cust.custDivDetail == 'SCD01', prospect: cust.custDivDetail == 'SCD02', mom: cust.custDivDetail == 'SCD03', exp: cust.custDivDetail == 'SCD04' }">{{cust.custDivDetailNm}}</em>
                <strong>{{cust.custNm}}</strong>
                <i>{{cust.tel1}}-{{cust.tel2}}-{{cust.tel3}}</i>
                <button type="button" class=""></button>
                <span class="radio">
                    <input type="radio" name="" :id="index" @click="selectedCust(index)">
                    <label :for="index"></label>
                </span>
            </li>
        </ul>
      <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
        <div slot="no-more"></div>
        <div slot="no-results">
          <div class="search-resutl-None">
            <p>등록된 고객이 없습니다.<br/>다시 검색해 주세요.</p>
          </div>
        </div>
      </infinite-loading>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "CustSearch",
  components: {
    InfiniteLoading
  },
  data() {
    return {
      searchCustNm: "",
      searchUserid: "",
			tot:0,
			offset: 0,	 //현재 가지고있는 갯수
			size : 10,	//한번에 가져오는 수
      custList: []
    };
  },
  methods: {
    infiniteHandler: function($state) {
      //console.log("SCROLL");
      var that = this;
      var parameters = {
        searchCustNm: this.searchCustNm,
        searchUserid: this.searchUserid,
        offset: this.offset,
        size: this.size
      };
      this.$api.commonPopup.custSearch(parameters)
        .then(function(res) {
          // console.log("CustSearch.vue <api.custSearch.custSearch.response> totCnt:",res.totCnt);
          // console.log("CustSearch.vue <api.custSearch.custSearch.response> custList:",res.custList);
          that.tot = res.totalCount;
          var list = res.custList;
          if (list.length) {
            that.offset += that.size;
            that.custList = that.custList.concat(list);
            $state.loaded();
            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    custSearch: function() { // 고객목록 조회
      this.tot = 0;
			this.offset = 0
			this.size = 10
      this.custList = [];
      this.$refs.InfiniteLoading.stateChanger.reset();
    },
    selectedCust: function(index) { // 고객 선택시 부모창에 key 전달.
      //console.log("CustSearch.vue selectedCust index", index);
      var selectedCustNm = this.custList[index].custNm;
      var selectedCustDiv = this.custList[index].custDiv;
      var selectedKwkkey = this.custList[index].kwkkey;
      //console.log("CustSearch.vue selectedCust selectedCustNm", selectedCustNm);

      var child = {
        name: "cust-selected",
        data: { custNm: selectedCustNm,
                custDiv: selectedCustDiv,
                kwkkey: selectedKwkkey,
                userId : this.searchUserid
              }
      };
      this.$utils.nativeIf.outbound.sendChildData(child);
    }
  }
  ,created: function() {
    // 하위 조직원 정보 넘어왔을때(지국장:에듀플랜맵>고객조회 시 사용됨.)
    if(!this.$utils.stringUtil.isNull(this.$route.params.userId)){
      this.searchUserid = this.$route.params.userId;
    }
  }
};
</script>
